<template>
  <div class="overseeDetail">
    <div class="item">
      <div class="item-inner bootomborder">
        <div class="title">
          <span>{{ detail.overseeOrgName }}的督办</span>
          <!-- <span v-if="!(detail && detail.state !== 'REVOERED' && detail.feedbackOrgId ===  userInfo.orgId)" class="state">已反馈</span> -->
          <span v-if="!(detail && detail.state !== 'REVOERED' )" class="state">已反馈</span>
        </div>
        <p class="info">发起时间：{{ detail.createTime | timeFilter }}</p>
        <p class="info">督办人：{{ detail.overseeUserName }}</p>
      </div>
    </div>

    <div class="item" v-if="detail && detail.state !== 'REVOERED' && detail.feedbackOrgId ===  userInfo.orgId">
      <div class="item-inner">
        <div class="title">
          <span>督办要求</span>
        </div>
        <p class="info mb12">{{ detail.overseeContent }}</p>
        <div class="imgbox">
          <img v-for="(item, index) in overseeImg" :key="index" @click="open(index, overseeImg)" class="img" :src="item" alt />
        </div>
      </div>
    </div>

    <div class="item grayitem" v-else>
      <div class="item-inner gray">
        <div class="title">
          <span>督办要求</span>
        </div>
        <p class="info mb12">{{ detail.overseeContent }}</p>
        <div class="imgbox">
          <img v-for="(item, index) in overseeImg" :key="index" @click="open(index, overseeImg)" class="img" :src="item" alt />
        </div>
      </div>
      <div class="greenBlock"></div>

    </div>
    <!-- 未反馈显示的内容 -->
    <!-- <div v-if="detail && detail.state === 'REVOERED'" class="item"> -->
    <!-- <div v-if="!(detail && detail.state !== 'REVOERED' && detail.feedbackOrgId ===  userInfo.orgId)" class="item grayitem"> -->
    <div v-if="!(detail && detail.state !== 'REVOERED' )" class="item grayitem">
      <div class="item-inner gray">
        <div class="title">
          <span>督办反馈</span>
        </div>
        <p class="info mb12">{{ detail.feedbackContent }}</p>
        <div class="imgbox" v-if="overseeFeedbackImg.length > 0">
          <img
            v-for="(item, index) in overseeFeedbackImg"
            :key="index"
            class="img"
            @click="open(index, overseeFeedbackImg)"
            :src="item"
            alt
          />
        </div>
        <p class="info">反馈机构：{{ detail.feedbackOrgName }}</p>
        <p class="info">反馈时间：{{ detail.feedbackTime | timeFilter }}</p>
      </div>
      <div class="greenBlock"></div>
    </div>

    <div v-if="detail && detail.state !== 'REVOERED' && detail.feedbackOrgId ===  userInfo.orgId" class="btn-box" @click="feedback">
      <div class="btn">反馈</div>
    </div>
  </div>
</template>

<script>
    import util from '../../../../utils/common';
    import api from '../../../../service/modules/refund';
    import { ImagePreview } from 'vant';
    export default {
        filters: {
            timeFilter (val) {
                return util.getStampInDate(val, '/');
            }
        },
        data () {
            return {
                detail: {},
                overseeImg: [], // 督办要求图片列表
                overseeFeedbackImg: [], // 督办反馈图片列表
                flowId: '',
                userInfo: {}
            };
        },
        created () {
            try {
                this.userInfo = this.$store.state.refund.userInfo
                this.detail = JSON.parse(this.$route.query.detail)
                // console.log('detail', this.detail.feedbackOrgId)
                // console.log('userinfo', this.userInfo.orgId)
                this.overseeImg = this.detail.overseeAttachList
                this.overseeFeedbackImg = this.detail.feedbackAttachList
                this.flowId = this.$route.query.flowId;
                // this.getDetail();
            } catch (err) {
                console.log(err)
            }
            console.log('detail.feedbackOrgId', this.detail.feedbackOrgId)
        },
        methods: {
            open (index, imgList) {
                  window.history.pushState(null, null, "#");
                const that = this
                ImagePreview({
                    images: imgList,
                    startPosition: index,
                    onClose() {
                      console.log('window.location.href', window.location.href);
                      if (window.location.href.indexOf('oversee') === -1) {
                        that.$router.back()
                      }
                    }
                });
            },
            // 反馈
            feedback () {
                this.$router.push({
                    path: '/refund/overseefeedback',
                    query: {
                        detail: this.detail,
                        flowId: this.flowId
                    }
                });
            },
            // 获取详情
            getDetail () {
                try {
                    api.detailList({ flowId: this.flowId }).then(res => {
                        if (res.ret === 0) {
                            // const overseeImg = res.data.attachments.overseeContent; // 督办要求图片列表
                            // const overseeFeedbackImg =
                            //     res.data.attachments.overseeFeedbackContent;
                            // const refundOverSeeList = res.data.refundOverSeeList;
                            // if (overseeImg.length > 0) {
                            //     overseeImg.map(item => {
                            //         refundOverSeeList.map(i => {
                            //             if (item.operationId == i.id) {
                            //                 overseeImg.push(item);
                            //             }
                            //         });
                            //     });
                            // }
                            // if (overseeFeedbackImg.length > 0) {
                            //     overseeFeedbackImg.map(item => {
                            //         refundOverSeeList.map(i => {
                            //             if (item.operationId == i.id) {
                            //                 overseeFeedbackImg.push(item);
                            //             }
                            //         });
                            //     });
                            // }
                        }
                    });
                } catch (err) {
                    alert(err);
                }
            }
        }
    };
</script>

<style lang="less" scoped>
.overseeDetail {
  background-color: white;
  min-height: 100vh;
  .item {
    padding: 21px 16px 0;
    .item-inner, .item-inner:first-child {
      padding-bottom: 28px;
      .title {
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        margin-bottom: 7px;
        .state {
          font-size: 14px;
          color: #36b374;
          font-weight: 400;
        }
      }
      .info {
        font-size: 14px;
        color: #999999;
        font-weight: 400;
        line-height: 24px;
      }
      .mb12 {
        margin-bottom: 12px;
      }
      .imgbox {
        display: flex;
        margin-bottom: 12px;
        .img {
          width: 80px;
          height: 80px;
          margin-right: 8px;
          border-radius: 4px;
        }
      }
    }
    .bootomborder {
        border-bottom: 1px solid #EEEEEE;
    }
  }
  .grayitem {
    padding-top: 0;
    position: relative;
    margin-bottom: 12px;
    .greenBlock {
      position: absolute;
      left: 16px;
      top: 19px;
      width: 4px;
      height: 12px;
      background: #36B374;
    }
    .gray {
      padding: 16px 16px 24px;
      background-color: #F8F9FC;
      border-radius: 4px;
    }
  }
  .btn-box {
    position: fixed;
    padding: 8px 16px 34px;
    width: 100%;
    box-shadow: 0 0 16px 0 rgba(0,0,0,0.05);
    bottom: 0;
    .btn {
      background: #36b374;
      border-radius: 4px;
      font-size: 16px;
      color: white;
      font-weight: 500;
      padding: 16px 0;
      text-align: center;
    }
  }
}
</style>
